import PropTypes from 'prop-types';
import React from 'react';
import Typography from '../../components/Typography';
import { TEXT_TRANSFORM, VARIANT_TYPOGRAPHY } from '../../enums';

import { Box, Menu, MenuItem, useTheme } from '@mui/material';

const LanguageSettings = ({ options, onChangeLanguage, toggleClose, toggleOpen, toggle }) => {
  const theme = useTheme();
  return (
    <Box>
      {/* <IconButton Icon={IconGlobe} onClick={toggleOpen} /> */}
      <Typography
        key={'01'}
        fontWeight={500}
        label={localStorage.getItem('i18nextLng') === 'en-US' ? 'ENG' : 'KO'}
        variant={VARIANT_TYPOGRAPHY.H6}
        onClick={toggleOpen}
        // style={{ padding: '5px 20px' }}
        textTransform={TEXT_TRANSFORM.CAPITALIZE}
        color={theme.palette.text.secondary}
        sx={{
          // padding: '5px 20px',
          color: '#FFFFFF', // Highlight active link
          fontFamily: 'Open Sans',
          fontWeight: '700 !important',
          position: 'relative',
          textTransform: 'none',
          fontSize: '16px',
          borderBottom: '2px solid transparent',
          cursor: 'pointer',
          '&:hover': {
            borderBottom: '2px solid #5B3EDE',
            color: '#9340BF',
          },
        }}
      />
      <Menu
        id="basic-menu"
        anchorEl={toggle}
        open={Boolean(toggle)}
        onClose={toggleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {options.map((item, index) => (
          <Box key={index}>
            <MenuItem onClick={() => onChangeLanguage(item.lang)}>{item.name}</MenuItem>
          </Box>
        ))}
      </Menu>
    </Box>
  );
};

LanguageSettings.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      lang: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  onChangeLanguage: PropTypes.func,
  toggleClose: PropTypes.func,
  toggleOpen: PropTypes.func,
  toggle: PropTypes.object,
};

export default LanguageSettings;
